import { render, staticRenderFns } from "./OtherReceiptListDetail.vue?vue&type=template&id=af98e5d0&scoped=true"
import script from "./OtherReceiptListDetail.vue?vue&type=script&lang=js"
export * from "./OtherReceiptListDetail.vue?vue&type=script&lang=js"
import style0 from "./OtherReceiptListDetail.vue?vue&type=style&index=0&id=af98e5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af98e5d0",
  null
  
)

export default component.exports